import * as z from "zod";
import { mutator } from "./mutator";

export const setUserPreference = mutator({
  schema: z.object({
    spaceSortOrder: z.enum(["alphabetical", "recency"]).optional(),
    defaultHome: z.string().optional(),
    soundClicks: z.enum(["on", "off"]).optional(),
    soundChat: z.enum(["on", "off"]).optional(),
    soundWorkflow: z.enum(["on", "off"]).optional(),
    theme: z.enum(["light", "dark", "system"]).optional(),
    defaultSpace: z.string().nullable().optional(),
    showCode: z.enum(["on", "off"]).optional(),
    browserNotifications: z.enum(["on", "off"]).optional(),
    planModeDefault: z.enum(["on", "off"]).optional(),
    planModeChatDefault: z.enum(["on", "off"]).optional(),
    planModeWorkflowDefault: z.enum(["on", "off"]).optional(),
    planModeBranchDefault: z.enum(["on", "off"]).optional(),
    showFeatureFlagsNav: z.enum(["on", "off"]).optional(),
    workflowTabOrder: z.string().nullable().optional(),
    navConfig: z.string().nullable().optional(),
    follow3bByDefault: z.enum(["on", "off"]).optional(),
    suggestFollow3b: z.enum(["on", "off"]).optional(),
    aiProviderId: z.string().nullable().optional(),
    followUpBehavior: z.enum(["queue", "steer"]).optional(),
  }),
  resolve: {},
  permissions: { none: "writes only the calling user’s own preference row" },
  fn: async ({ tx, ctx, args }) => {
    const { userId } = ctx;
    await tx.mutate.userPreferences.upsert({
      userId,
      tenantId: ctx.tenantId,
      ...args,
    });
  },
});
